






























import { defineComponent, computed, ref } from "@vue/composition-api";
import NotificationModel from "@/ts/models/notificationClass";
import useFetcher from "@/ts/functions/composition/useFetcher";
import LinkNotification from "../components/molecules/notification/LinkNotification.vue";
import Notification from "../components/molecules/notification/Notification.vue";

export default defineComponent({
  name: "Notifications",

  components: {
    LinkNotification,
    Notification
  },

  setup() {
    var { entity: notifications, loading } = useFetcher(
      "notification/GET_NOTIFICATIONS"
    );

    var page = ref(1);

    const notificationsPerPage = 5;

    var pagesCount = computed(() => {
      if (notifications.value) {
        return Math.ceil(notifications.value.length / notificationsPerPage);
      } else {
        return 0;
      }
    });

    var activeNotifications = computed(() => {
      if (notifications.value) {
        return notifications.value.slice(
          page.value * notificationsPerPage - notificationsPerPage,
          page.value * notificationsPerPage
        );
      }
    });

    return {
      notifications,
      loading,
      activeNotifications,
      pagesCount,
      page
    };
  }
});
